import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Link, useNavigate } from 'react-router-dom';
import { getHeaders, headers } from '../../http/axios';
import { GlobalContext } from '../../App';
import Pagination from '../../components/Common/pagination/Pagination';
import { toast } from 'react-toastify';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';

export default function Blogs() {
    const [blogData, setBlogData] = useState([]);
    const { setSpinner } = useContext(GlobalContext);
    const [open, setOpen] = useState(false);
    const [selectedBlogId, setSelectedBlogId] = useState(null);

    // ---------- pagination
    const [page, setPage] = useState(1);
    const [paginationData, setPaginationData] = useState();
    const navigate = useNavigate();
    const imageUrl = "./assets/images/";

    const blogDetail = (blog) => {
        const titleSlug = blog.blog_title.replace(/\s+/g, '-').toLowerCase(); // Create a slug from the title
        navigate(`/blog/blog-detail/${titleSlug}`, { state: { content: blog } });
    };
    const stripHtmlTags = (html) => {
        return html.replace(/<\/?[^>]+>/gi, '');
    };


    const columns = [
        {
            name: 'S.No.',
            selector: (row, index) => index + 1 + (page - 1) * 10,
            width: "5",
        },
        {
            name: 'Title',
            selector: row => row.blog_title || '',
            width: "15",
            sortable: true,
        },
        {
            name: 'Content',
            selector: row => <p className='Sora_R text-base whitespace-pre	w-[350px] text-nowrap truncate desc-text' dangerouslySetInnerHTML={{ __html: stripHtmlTags(row.content) }}></p> || '',
            width: "25",
        },
        {
            name: 'Category',
            selector: row => row.category?.name || '',  // Access nested category name
            width: "15",
        },
        {
            name: 'Author',
            selector: row => row.author?.name || '',  // Access nested author name
            width: "10",
        },
        {
            name: 'Banner',
            selector: row => (
                <div>
                    <img src={(row?.banner_image && row.banner_image !== "undefined") ? row?.banner_image : imageUrl + "dummy.png"} alt="" className={`rounded-[4px] ${(row?.banner_image && row.banner_image !== "undefined") ? "opcaity-100 h-[100px] w-[100px] object-contain" : "opacity-50  m-auto  w-[60px]"}`} />
                    {(row?.banner_image && row.banner_image !== "undefined") ? "" : <span className='text-[12px] Sora_B mt-1 block text-center'>No image</span>}
                </div>
            ),
            width: "10",
        },
        {
            name: 'Thumbnail',
            selector: row => (
                <>
                    <img src={(row?.thumbnail_image && row.thumbnail_image !== "undefined") ? row?.thumbnail_image : imageUrl + "dummy.png"} alt="" className={`rounded-[4px] ${(row?.thumbnail_image && row.thumbnail_image !== "undefined") ? "opcaity-100 h-[100px] w-[100px] object-contain" : "opacity-50  m-auto  w-[60px]"}`} />
                    {(row?.thumbnail_image && row.thumbnail_image !== "undefined") ? "" : <span className='text-[12px] Sora_B mt-1 block text-center'>No image</span>}
                </>
            ),
            width: "10",
        },
        {
            name: 'Action',
            width: "10",
            selector: row => (
                <>
                    <div className="flex items-center gap-4">
                        <button onClick={() => blogDetail(row)}>
                            <img src={imageUrl + "view.svg"} alt="" width="20px" />
                        </button>
                        <Link to={"/blog/editBlog/" + row?.id}><img src={imageUrl + "PencilSquare.svg"} alt="" /></Link>
                        <button onClick={() => { setOpen(true); setSelectedBlogId(row?.id); }}><img src={imageUrl + "Trash.svg"} alt="" /></button>
                    </div >
                </>
            )
        },
    ];
    // get blog
    const getBlogData = (page) => {
        setSpinner(true);
        axios.get(
            `${process.env.REACT_APP_API_KEY}blog?page=${page}`,
            { headers: getHeaders() }
        )
            .then((res) => {
                const { current_page, last_page, per_page, total, data } = res?.data?.data;
                setPaginationData({ current_page, last_page, per_page, total });
                setBlogData(data || []);
            })
            .finally(() => {
                setSpinner(false);
            });
    };
    /// dellete blog
    const handleDeleteBlog = () => {
        axios
            .delete(`${process.env.REACT_APP_API_KEY}blog/${selectedBlogId}`, {
                headers: getHeaders(),
            })
            .then((response) => {
                toast.success("Blog deleted ,Successfully!");
                getBlogData();
                setOpen(false)
            })
            .finally(() => {
                setSpinner(false);
            });
    };

    useEffect(() => {
        getBlogData(page);
    }, [page]);

    // ---------- pagination
    const handlePageClick = (data) => {
        setPage(data.selected + 1);
    };
    return (
        <>
            <div className="title flex justify-between items-center mb-5">
                <h2>Blogs</h2>
                <div className="flex search-dropdown gap-6">
                    {/* <div className="search-box rounded w-[400px]">
                        <img src={imageUrl + "serach.svg"} alt="" />
                        <input
                            type="search"
                            placeholder="Search Blog"
                            className='w-full'
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                        }}
                        />
                    </div> */}
                    <Link to="/blog/addBlog" className="primaryBG text-white px-8 py-3 rounded ">
                        <img src="./assets/images/plus.svg" alt="" />
                        Add Blog
                    </Link>
                </div>
            </div>
            <div className="data-box responsive-table">
                <DataTable
                    className='rounded-none saras-table'
                    columns={columns}
                    data={blogData}
                />
                {paginationData?.total > 10 && <Pagination
                    pageNumber={paginationData?.from}
                    perPage={paginationData?.to}
                    paginationList={10}
                    pageRange={paginationData?.total}
                    onPageActive={paginationData?.current_page}
                    pageCount={paginationData?.last_page}
                    handlePageClick={handlePageClick}
                    paginationClass="justify-content-end "
                    
                />}
            </div>
            {/*  delete modal  */}
            <Dialog open={open} onClose={setOpen} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                        >
                            <div className="bg-white px-4  sm:p-8 sm:pb-4">
                                <div className="text-center">
                                    <div className="rounded-full bg-red-100 w-12 m-auto mb-5">
                                        <img src={imageUrl + "bin.png"} alt="" className='m-auto' />
                                    </div>
                                    <div className="pt-6 pb-4 text-center sm:mt-0 sm:text-left">
                                        <DialogTitle as="h3" className="mb-2 text-base font-semibold leading-6 text-gray-900 text-center">
                                            Delete Blog
                                        </DialogTitle>
                                        <div className="mt-2">
                                            <p className="text-sm text-gray-500 text-center">
                                                Are you sure you want to delete this blog? All of your this blog data will be permanently removed.
                                                This action cannot be undone.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                <button
                                    type="button"
                                    onClick={handleDeleteBlog}
                                    className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                                >
                                    Delete
                                </button>
                                <button
                                    type="button"
                                    data-autofocus
                                    onClick={() => setOpen(false)}
                                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                >
                                    Cancel
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
